import board from "./modules/board"

const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    username: state => state.user.username,
    userid: state => state.user.userid,
    isadmin: state => state.user.isadmin,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    permission_routes: state => state.permission.routes,
    errorLogs: state => state.errorLog.logs,
    contnetwidth: state => state.screen.width - (state.app.sidebar.opened ? 210 : 54),
    boards: state => state.board.boards,
    boardedit: state => state.board.isedit
}
export default getters
